import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-street-light-planner-step2',
  templateUrl: './street-light-planner-step2.component.html',
  styleUrls: ['./street-light-planner-step2.component.scss'],
})
export class StreetLightPlannerStep2Component implements OnInit {
  @Input() minPrice = 10000;
  @Input() maxPrice = 200000;
  public readonly step = 10000;

  public readonly budgetHtml = `<p>Ihr Preisrahmen bestimmt die Anzahl der LEDs, die wir Ihnen zur Umrüstung empfehlen</p>`;
  public readonly budgetChoiceHtml = `<p>Sie haben keine genaue Budgetvorgabe? Wir zeigen Ihnen, welche Auswirkungen eine LED-Komplettumrüstung auf Ihren jährlichen
    Energieverbrauch hat und mit welchen Kosten die Umrüstung verbunden ist.</p>`;

  @Output() budgetChange = new EventEmitter();
  @Output() iSBudgetChange = new EventEmitter();

  @Input() isBudget = true;
  @Input() budget = this.minPrice;

  ngOnInit() {
    this.budgetChange.emit(this.budget);
    this.iSBudgetChange.emit(this.isBudget);
  }

  toggleBudget() {
    this.isBudget = !this.isBudget;
    this.iSBudgetChange.emit(this.isBudget);
  }
}
